import { getSysPlatformConfigByKeyList } from "@/api/business";
export default {
  data() {
    return {
      noticeList: []
    }
  },
  methods: {
    // 获取配置的方法
    async getConfig() {
      try {
        let { data } = await getSysPlatformConfigByKeyList();
        this.noticeList = data;
      } catch (error) {
        console.error("获取配置失败:", error);
      }
    },
    // 通用方法：根据 configKey 获取配置项的值
    getConfigValueByKey(configKey, defaultValue = "") {
      const config = this.noticeList.find(item => item.configKey === configKey);
      return config ? config.configValue : defaultValue;
    },
  }
}